import { Controller } from "@hotwired/stimulus"
import { Sortable, MultiDrag } from "sortablejs"
import { patch } from "@rails/request.js"

// Connects to data-controller="sortable"
export default class extends Controller {
  static values = {
    url: String,
    handle: String,
    multiDrag: Boolean,
    options: Object,
    selectedClass: String,
  }

  initialize() {
    if (this.multiDragValue) {
      Sortable.mount(new MultiDrag())
    }
    this.onUpdate = this.onUpdate.bind(this)
  }

  connect() {
    this.sortable = new Sortable(this.element, {
      ...this.defaultOptions,
      ...this.optionsValue,
    })
  }

  disconnect() {
    this.sortable.destroy()
    this.sortable = undefined
  }

  onEnd = event => {
    this.dispatch("end", { detail: { event } })
  }

  onUpdate = async event => {
    if (!this.urlValue) return

    const data = this.serialize(this.element)

    await patch(this.urlValue + "?" + data, {
      contentType: "text/javascript",
    })

    this.dispatch("update", { detail: { event } })
  }

  // Borrowed from JQuery UI Sortable
  serialize(o) {
    var items = o.children,
      str = []
    o = o || {}

    $(items).each(function () {
      var res = ($(o.item || this).attr(o.attribute || "id") || "").match(
        o.expression || /(.+)[\-=_](.+)/
      )
      if (res) {
        str.push(
          (o.key || res[1] + "[]") +
            "=" +
            (o.key && o.expression ? res[1] : res[2])
        )
      }
    })

    if (!str.length && o.key) {
      str.push(o.key + "=")
    }

    return str.join("&")
  }

  get defaultOptions() {
    return {
      multiDrag: this.multiDragValue || false,
      selectedClass: this.selectedClassValue || "sortable-selected",
      handle: this.handleValue || undefined,
      onUpdate: this.onUpdate,
      onEnd: this.onEnd,
    }
  }
}
